export interface Shortcut {
  key: string;
  route: any;
  param: any;
  status: any;
  beschreibung: string;
}

export const SHORTCUTS: Shortcut[] = [
  { key: 'h', status: 'link', route: 'home', param: '', beschreibung: 'Home' },
  { key: 's', status: 'link', route: 'speiseplan-kunde', param: '', beschreibung: 'Speiseplan' },
  { key: 'w', status: 'link', route: 'warenkorb', param: '', beschreibung: 'Warenkorb' },
  { key: 'b', status: 'link', route: 'bestellhistorie', param: '', beschreibung: 'Bestellhistorie' },
  { key: 'r', status: 'link', route: 'rechtliches', param: 'agb', beschreibung: 'Rechtstexte' },
  { key: 'q', status: 'link', route: 'rechtliches', param: 'faq', beschreibung: 'FAQ' },
  { key: 'u', status: 'footer-menu', route: 'footer', param: '', beschreibung: 'Footer' },
  { key: 'o', status: 'toolbar-navigation', route: 'toolbar', param: '', beschreibung: 'Toolbar' },
  { key: 'k', status: 'farbkatalog', route: '', param: '', beschreibung: 'Farbpalette' }
]
